import SlideFrame from "./_SlideFrame";

const markets = [
  { t: "Fintech lenders", d: "Fast-growing digital lending operations." },
  { t: "Credit unions", d: "Member-focused institutions modernizing servicing." },
  { t: "Bank partnerships", d: "Banks expanding lending programs & white-label." },
  { t: "Embedded finance platforms", d: "Non-bank platforms offering credit products." },
];

export default function SlideWhoWeWorkWith() {
  return (
    <SlideFrame tag="08 · Market">
      <p className="overline mb-6">Target markets</p>
      <h2 className="font-display text-5xl md:text-6xl tracking-tighter leading-[0.95] font-medium max-w-4xl">
        We sit <em className="italic text-primary">behind</em> the lender.
      </h2>

      <div className="mt-14 grid md:grid-cols-2 gap-px bg-foreground/20 border border-foreground/20">
        {markets.map((m, i) => (
          <div key={i} className="bg-background p-10">
            <p className="font-mono-data text-xs text-muted-foreground">{String(i + 1).padStart(2, "0")}</p>
            <h3 className="font-display text-3xl md:text-4xl tracking-tight mt-3">{m.t}</h3>
            <p className="mt-4 text-muted-foreground leading-relaxed max-w-sm">{m.d}</p>
          </div>
        ))}
      </div>
    </SlideFrame>
  );
}
